import React from 'react';
import { useParams } from "react-router-dom";
import './productpage.styles.scss'; // We will add styles here in the next step
import CustomDrawer from '../../components/drawer/drawer.component';
import Products from '../products/products.component';

function ProductPage() {
  let { section } = useParams();
  return (
    <div className="dashboard-layout">
      <CustomDrawer section={"products"} />
        <div className="main-content">
        <Products />
      </div>
    </div>
  );
}

export default ProductPage;